import { useState, useCallback } from 'react';

export type PasswordValidation = {
  hasLower: boolean;
  hasUpper: boolean;
  hasDigit: boolean;
  isValid: boolean;
};

const validate = (password: string): PasswordValidation => {
  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  return { hasLower, hasUpper, hasDigit, isValid: hasLower && hasUpper && hasDigit };
};

/**
 * Manages password input state and inline validation for the sensitive data token.
 * Validation rules mirror the legacy sensitiveData.js requirements:
 * at least one lowercase letter, one uppercase letter, and one digit.
 */
export const useSensitiveDataPassword = () => {
  const [password, setPasswordState] = useState('');

  const setPassword = useCallback((value: string) => setPasswordState(value), []);

  const reset = useCallback(() => setPasswordState(''), []);

  return { password, setPassword, validation: validate(password), reset };
};
